export enum Environment {
  Local,
  Production,
  Development,
}

export const getEnvironment = (): Environment => {
  const hostname = window.location.hostname;
  if (hostname === 'partner.vytal.org' || hostname === 'appadmin.vytal.org') {
    return Environment.Production;
  } else if (
    hostname === 'appadmin.testing.internal.vytal.org' ||
    hostname === 'partner-dev.vytal.org' ||
    hostname === 'appadmin-dev.vytal.org' ||
    // PR previews (pr<N>-admin-dev.preview.vytal.org): a full stack per pull
    // request, dev-stage by construction — see preview/README.md. Suffix match
    // because the PR number varies. Without this the throw below takes down
    // every chunk that calls getEnvironment() at module scope.
    hostname.endsWith('.preview.vytal.org')
  ) {
    return Environment.Development;
  } else if (
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname.endsWith('tunnel.yigit.link') ||
    hostname.endsWith('trycloudflare.com')
  ) {
    return Environment.Local;
  }
  throw new Error('Unknown environment: ' + hostname);
};
